import React, { useState } from "react";
import { Button, Col, Image, Row } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";

import useMapData from "../../utils/useMapData";

import { ModalOverlay } from "../Modal/Modal";
import CostBreakupTable from "../CostBreakupTable/CostBreakupTable";
import PriceBreakdown from "../Price/PriceBreakdown";
import { CostDetailText, VerticalText } from "../../StyledCmp";

const Price = React.forwardRef((props, ref) => {
  const { propertyId } = useParams();
  const resultList = useMapData(propertyId);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleModalVisibility = () => {
    setIsModalVisible(prevState => !prevState);
  };

  return (
    <Row className="cost_breakdown_wrapper" ref={ref}>
      <div id="horizontal_text">
        <h1 style={{ color: resultList?.themeColor }}>Price</h1>
      </div>
      <Col lg={14}>
        <CostBreakupTable handleModalVisibility={handleModalVisibility} />
        <Row className="price_mobile">
          {resultList?.sitePlanDetails?.map((plan, index) => {
            let isEven = index % 2 === 0;
            return (
              <React.Fragment key={plan.title}>
                <PriceBreakdown
                  title={plan.title}
                  isEven={isEven}
                  carpetArea={plan.carpetArea}
                  price={plan.price}
                  handleModalVisibility={handleModalVisibility}
                />
              </React.Fragment>
            );
          })}
        </Row>
      </Col>
      <Col lg={7}>
        <div className="content" onClick={handleModalVisibility}>
          <div className="content-overlay"></div>
          <Image
            src={resultList?.costingDetailImage}
            onContextMenu={e => e.preventDefault()}
            preview={false}
            // id="blur_image"
          />
          <div className="content-details fadeIn-bottom">
            <Button
              style={{ background: resultList?.themeColor }}
              id="content-title"
              icon={<EyeOutlined />}
            >
              Enquire Now
            </Button>
          </div>
        </div>
        <CostDetailText>
          <p style={{ color: resultList?.themeColor }}>
            Complete Costing Details
          </p>
        </CostDetailText>
      </Col>
      <Col lg={1}>
        <div className="vertical_text">
          <VerticalText>Price</VerticalText>
        </div>
      </Col>
      {isModalVisible && (
        <ModalOverlay
          isModalVisible={isModalVisible}
          handleModalVisibility={handleModalVisibility}
          title={"Send Me Costing Details"}
          btnText="Send Now"
          actionType="send-costing-details"
        />
      )}
    </Row>
  );
});

export default Price;
